export default __webpack_public_path__ + "static/media/production.2d0845bf.png";